import { gql } from '@apollo/client';

// One backend query for every group of the search input. Each group pages on
// its own: pass `categories: [buildings], page: 2` for "load more".
export const LOAD_SEARCH_INPUT_ITEMS = gql`
  query (
    $text: String!
    $categories: [SearchInputCategory!]
    $page: Int
    $selected: SearchInputSelectedInput
  ) {
    searchInputItems(
      text: $text
      categories: $categories
      page: $page
      selected: $selected
    ) {
      category
      page
      pageCount
      items {
        id
        label
        slug
        link
      }
    }
  }
`;

export const GET_NEIGHBORHOOD_FILTER = gql`
  query ($id: ID!) {
    neighborhood(id: $id) {
      data {
        id
        attributes {
          name
          slug
          city {
            data {
              id
              attributes {
                name
                slug
                county {
                  data {
                    id
                    attributes {
                      name
                      slug
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_BUILDING_FILTER = gql`
  query ($id: ID!) {
    building(id: $id) {
      data {
        id
        attributes {
          name
          slug
          isPreconstruction
          primaryAddress
          neighborhood {
            data {
              id
              attributes {
                name
                slug
                city {
                  data {
                    id
                    attributes {
                      name
                      slug
                      county {
                        data {
                          id
                          attributes {
                            name
                            slug
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_SEARCHBOX_URL_FILTERS = gql`
  query (
    $addresses: [String]
    $buildings: [String]
    $cities: [String]
    $counties: [String]
    $neighborhoods: [String]
    $loadAddresses: Boolean!
    $loadBuildings: Boolean!
    $loadCities: Boolean!
    $loadCounties: Boolean!
    $loadNeighborhoods: Boolean!
  ) {
    cities(filters: { slug: { in: $cities } }, pagination: { limit: 30 })
      @include(if: $loadCities) {
      data {
        id
        attributes {
          name
          slug
        }
      }
    }
    counties(filters: { slug: { in: $counties } }, pagination: { limit: 30 })
      @include(if: $loadCounties) {
      data {
        id
        attributes {
          name
          slug
        }
      }
    }
    neighborhoods(
      filters: { slug: { in: $neighborhoods } }
      pagination: { limit: 30 }
    ) @include(if: $loadNeighborhoods) {
      data {
        id
        ...NeighborhoodData
      }
    }
    buildings(filters: { slug: { in: $buildings } }, pagination: { limit: 30 })
      @include(if: $loadBuildings) {
      data {
        id
        ...BuildingData
      }
    }
    addresses: buildings(
      filters: { primaryAddress: { in: $addresses } }
      pagination: { limit: 30 }
    ) @include(if: $loadAddresses) {
      data {
        id
        ...BuildingData
      }
    }
  }
  fragment BuildingData on BuildingEntity {
    attributes {
      name
      slug
      isPreconstruction
      primaryAddress
      neighborhood {
        data {
          id
          ...NeighborhoodData
        }
      }
    }
  }

  fragment NeighborhoodData on NeighborhoodEntity {
    attributes {
      name
      slug
      city {
        data {
          id
          attributes {
            name
            slug
            county {
              data {
                id
                attributes {
                  name
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`;
